import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Compass, Users, Calendar, User, Sparkles, Coffee } from 'lucide-react';

const BottomNav = ({ user }) => {
  const location = useLocation();
  if (!user) return null;

  const tabs = [
    { path: '/', icon: Sparkles, label: 'Explore' },
    { path: '/groups', icon: Users, label: 'Clubs' },
    { path: '/hangouts', icon: Coffee, label: 'Hangouts' },
    { path: '/events', icon: Calendar, label: 'Events' },
    { path: '/profile', icon: User, label: 'Me' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 dark:bg-[#1a1f26]/95 backdrop-blur-xl border-t border-gray-200/60 dark:border-[#2d3544]/80 safe-area-pb">
      <div className="flex items-center justify-around h-16 px-2">
        {tabs.map(({ path, icon: Icon, label }) => {
          const isActive = location.pathname === path ||
            (path === '/groups' && location.pathname.startsWith('/groups')) ||
            (path === '/hangouts' && location.pathname.startsWith('/hangouts'));
          return (
            <Link
              key={path}
              to={path}
              className={`flex flex-col items-center justify-center flex-1 py-2 gap-1 transition-colors ${
                isActive
                  ? 'text-blue-600 dark:text-cyan-400'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
              }`}
            >
              <Icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 1.5} />
              <span className="text-[11px] font-medium">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
